import { FC, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { GoogleMap } from "./GoogleMap";

type TabGoogleMapProps = {
  dataSource: any[];
};

export const TabGoogleMap: FC<TabGoogleMapProps> = ({ dataSource }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  return (
    <div className="flex flex-col gap-2">
      <button
        className="bg-[var(--sky-primary)] px-3 py-1 rounded-lg text-white ml-auto"
        onClick={() => reactToPrintFn()}
      >
        Download PDF
      </button>

      <div ref={contentRef as never}>
        <h1 style={{ fontSize: "2rem" }}>แผนที่</h1>
        <GoogleMap dataSource={dataSource} />
      </div>
    </div>
  );
};
